const UPPER_WORDS = new Set(['tv', 'dj', 'vr', 'ar', 'ai', 'ep', 'lp']);

export const formatMediaTagName = (name: string): string =>
  name
    .split('_')
    .map((word) => {
      const lower = word.toLowerCase();
      if (UPPER_WORDS.has(lower)) return lower.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
